<template>
  <div id="pers-tab17" name="hres31x-tab17" class="content-pers" :class="{'-fixed-height-box' : pcDisp}">
    <template v-for="(value, index) in detail.tableDocument.rows">
      <detail-template
        :index="index"
        :labels="labels"
        :detail="detail"
        inline-template>
        <div>
          <div slot="head" class="sub-topic-box color-skin" @click="toggleDisp()">
            <i class="fa fa-file-o icon-sub-topic" aria-hidden="true"></i>
            <div class="sub-topic">{{ labels['HRES31XC16']['10'] }} ( {{ labels['HRES31XC16']['20'] }}  {{ index + 1 }} )</div>
          </div>

          <div slot="body" class="data-pers-box" v-show="topicDisp">
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC16']['30'] }}</div>
              <div class="col-xs-6 data-text">{{ value.typdoc }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC16']['40'] }}</div>
              <div class="col-xs-6 data-text">{{ value.namdoc }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC16']['50'] }}</div>
              <div class="col-xs-6 data-text">{{ setDateOutput(value.dterecv) }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC16']['60'] }}</div>
              <div class="col-xs-6 data-text">{{ setDateOutput(value.dtedocen) }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC16']['70'] }}</div>
              <div class="col-xs-6 data-text">{{ value.numdoc }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC16']['80'] }}</div>
              <div class="col-xs-6 data-text">
                <template v-if="value.filedoc === '-'">
                  -
                </template>
                <template v-else>
                  <a :href="value.path_filedoc" target="_blank" @click.stop><i class="fa fa-paperclip"></i> {{ value.filedoc }}</a>
                </template>
              </div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC16']['90'] }}</div>
              <div class="col-xs-6 data-text">{{ value.desnote }}</div>
            </div>
          </div>
        </div>
      </detail-template>
    </template>
  </div>
</template>

<script>
import detailTemplate from 'components/hres31x/detailTemplate'

export default {
  name: 'hres31x-tab17',
  components: {
    detailTemplate
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'triggerButton' ]
}
</script>


// WEBPACK FOOTER //
// tab17.vue?18442483